/* eslint-disable import/prefer-default-export */
export const initialStateApplications = {
  // List of applications
  data: [],
  isLoading: false,
};
